import {useSelector} from 'react-redux';
import {Outlet} from 'react-router-dom';
import Message from '../alert/Message';
import LegalModals from '../common/legal-infos/LegalModals';
import CookieBanner from '../consent/CookieBanner';
import Footer from '../header/Footer';
import Header from '../header/Header';
import NavigationContext, {useNavigationContext} from '../header/NavigationContext';
import SideBar from '../header/SideBar';
import {RouterProps} from '../../router';
import {RootState} from '../../store';

const RootLayout = (props: RouterProps) => {
    const navigationContext = useNavigationContext();
    const message = useSelector((state: RootState) => state.message.message);

    return (
        <NavigationContext.Provider value={navigationContext}>
            {props.loggedIn && (
                <>
                    <Header />
                    <SideBar />
                    <LegalModals
                        showDataPrivacyModal={props.showDataPrivacyModal}
                        showTermsOfUseModal={props.showTermsOfUseModal}
                        showLegalHintsModal={props.showLegalHintsModal}
                        setShowDataPrivacyModal={props.setShowDataPrivacyModal}
                        setShowTermsOfUseModal={props.setShowTermsOfUseModal}
                        setShowLegalHintsModal={props.setShowLegalHintsModal}
                        userHasAcceptedDataPrivacy={props.userHasAcceptedDataPrivacy}
                        userHasAcceptedTermsOfUse={props.userHasAcceptedTermsOfUse}
                    />
                </>
            )}
            {message && <Message {...message} />}
            <Outlet />
            <Footer />
            <CookieBanner />
        </NavigationContext.Provider>
    );
};

export default RootLayout;
